import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  // Admin routes use the admin token. The public form endpoints (`/submissions*`)
  // may optionally carry the locatore token so the backend can auto-attach
  // `user_id` on new submissions (see server.py `_optional_locatore_id`).
  const path = (config.url || "").split("?")[0];
  const isAdminPath = /^\/(admin|auth)(\/|$)/.test(path);
  const adminToken = localStorage.getItem("cc_admin_token");
  const userToken = localStorage.getItem("cc_user_token");
  if (isAdminPath && adminToken) {
    config.headers.Authorization = `Bearer ${adminToken}`;
  } else if (!isAdminPath && userToken) {
    config.headers.Authorization = `Bearer ${userToken}`;
  } else if (adminToken) {
    // Fallback (admin browsing utility) — preserves legacy behaviour for
    // pages that still expect admin auth on non-/admin paths.
    config.headers.Authorization = `Bearer ${adminToken}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401 && window.location.pathname.startsWith("/admin") && window.location.pathname !== "/admin/login") {
      localStorage.removeItem("cc_admin_token");
      window.location.href = "/admin/login";
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Errore imprevisto";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" • ");
  return String(detail);
}

export function formatEuro(v) {
  const n = Number(v || 0);
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
  }).format(n);
}

export default api;
